{
  "changedSuccessfully": "Lösenordet har bytts",
  "setPasswordText": "Ange ett nytt lösenord",
  "passwordChangeFailedText": "Lösenordet kunde inte bytas",
  "errorCauses": {
    "wrongCode": "fel bekräftelsekod",
    "expiredCode": "bekräftelsekoden är föråldrad",
    "wrongPassword": "lösenordet uppfyller inte kraven",
    "tooManyAttempts": "för många försök",
    "userNotConfirmed": "användarens e-postadress har inte bekräftats",
    "userNotFound": "användaren hittades inte"
  },
  "resetCodeSent": "En bekräftelsekod som behövs för att byta lösenordet har skickats till din e-postadress",
  "resetCodeSent2": "Kontrollera skräppostmappen om du inte har fått något e-postmeddelande",
  "resetCodeInputLabel": "Bekräftelsekod",
  "resetCodeSubmitButtonText": "Byt lösenord",
  "forgotPasswordViewInputEmailDescription": "Ange den e-postadress du använder på boendesidorna.",
  "sendForgotPasswordEmailButtonText": "Skicka begäran",
  "passwordForgottenHeader": "Glömt lösenord",
  "resetUser": {
    "text": "Om du inte kommer ihåg kontot du registrerat dig med, kan du registrera dig igen",
    "resetLinkText": "här"
  }
}
